export default __webpack_public_path__ + "static/media/speak.419199f8.jpg";